module.exports = "<nuc-navigation></nuc-navigation>\n<div class=\"ruleEngine\">\n\t<router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules.component.html
// module id = 1449
// module chunks = 1